import { render, staticRenderFns } from "./BasePost.vue?vue&type=template&id=067db548"
import script from "./BasePost.vue?vue&type=script&lang=js"
export * from "./BasePost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports